export const CAMPAIGN_VALIDATION = {
  NAME: "Please enter campaign name",
  RATIO: "Please enter proper ratio, It will be between 1-100",
  WEEKDAYS: "Please enter weekdays",
  TIME: "Please enter time",
  PREVIEWTIMER: "Please enter proper preview timer, It will be between 1-1800",
  REQUESTPERSECOND:
    "Please enter proper request per second, It will be between 1-5000",
  RINGTIME: "Please enter proper ringtime, It will be between 21-45",
  CALLERIDS: "Please select a Caller ID before proceeding to the next step.",
  FLOW: "Please enter flow",
  TEAM: "Please enter team",
  WHATSAPPNUMBER: "Please enter WhatsApp Number",
  WHATSAPPTEMPLATE: "Please enter WhatsApp Template",
  SMSTEMPLATE: "Please enter SMS Template",
  RCSPROVIDER: "Please enter RCS Provider",
  SMSPROVIDER: "Please enter SMS Provider",
  SMSSENDER: "Please enter SMS Sender",
  GETMESSAGE: `This Campaign is either deleted or not currently accessible.`,
  WRONG: "Something went Wrong",
};

export const USER_VALIDATION = {
  NAME: "Please enter valid name.",
  MOBILE_NUMBER: "Mobile Number Required",
  PHONE_TYPE: "Please enter phone type.",
  EMAIL: "Please enter email.",
  ACCESSROLE: "Please enter valid Access Role",
};

export const SKILL_VALIDATION = {};

export const PROVIDER_VALIDATION = {
  INBOUND_OUTBOUND: "Select either inbound or outbound",
  IP_ADDRESS: "Enter valid inbound IP address",
  INBOUND_PORT: "Enter valid inbound port",
  OUTBOUND_PROXY: "Enter valid outbound proxy",
  OUTBOUND_DOMAIN: "Enter valid outbound domain",
  OUTBOUND_PORT: "Enter valid outbound proxy port",
  SINGLE_IP_ADDRESS: "Enter At List Single Proper Ip Address",
  INITIAL_PULSE: "Please add initial pulse",
  SUBSEQUENT_PLUSE: "Please add subsequent Pulse",
  RATE: "Please add default rate",
};

export const CARRIER_RATE_VALIDATION = {
  RATE: "Value of rate must be between 0.000001 to 1000",
  CONNECTION_CHARGE:
    "Value of connection charge must be between 0.000001 to 1000",
  COUNTRY_CODE: "Enter valid Country Code",
};

export const PHONE_NUMBER_VALIDATION = {
  PROVIDER: "Please select provider",
  PHONE_NUMBER: "Enter Valid Phone Number",
  URL: "Enter a valid URL.",
  METHOD: "Please select a valid method",
  FLOW: "Please select flow.",
};

export const MISSED_CALL_TO_CAMPAIGN_VALIDATION = {
  ACTION: "Action is required",
  DID: "DID is required",
  CAMOAIGN: "Campaign is required",
};

export const DISPOSITION_VALIDATION = {};

export const CONTACT_LIST_VALIDATION = {};

export const CONTACT_LIST_PRIVATE_VALIDATION = {};

export const SOUND_VALIDATION = {
  SOUND: `You haven't selected any sound.`,
};

export const BREAK_VALIDATION = {};

export const DNC_VALIDATION = {};

export const HOLIDAY_VALIDATION = {
  SOUND: `You haven't selected any sound.`
}

export const HOLIDAY_GROUP_VALIDATION = {};







// WEBPACK FOOTER //
// src/modules/common/utils/Validation/Validation.js